import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from "redux";
import { composeWithDevTools } from '@redux-devtools/extension';
import createSagaMiddleware from "redux-saga";
import rootReducer from "./reducer/index.js";
import rootSaga from "./saga/index.js";

const sagaMiddleware = createSagaMiddleware();
const store = composeWithDevTools(applyMiddleware(sagaMiddleware))(createStore)(
  rootReducer
);

sagaMiddleware.run(rootSaga);

export default store;
